import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import Tooltip from 'chameleon/ui-stack/ui/base/tooltip';
import Title from './Title';
import useResourcesInfo from './useResourcesInfo';

const ResourceTitles = ({ resources, onRemove }) => {
  const {
    resourcesInfo,
    showAll,
    button: toggleButton,
  } = useResourcesInfo(resources);
  const truncateSizeLength = onRemove ? 25 : 30;

  return (
    <div className="flex items-center">
      <ul
        className={cn('w-full list-none m-0 p-0 flex mb-4.2 flex-wrap', {
          'justify-between': !showAll && resources.length > 3,
        })}
      >
        {resourcesInfo.map(({ id, value: title, alreadyAssigned }) => {
          const truncateTitle = title.length > truncateSizeLength;

          return (
            <li
              data-test-id="resource-title-list-item"
              key={id}
              className={cn('mr-4.2 mb-4.2', { 'w-800': truncateTitle })}
            >
              <Title
                id={id}
                isAlert={alreadyAssigned}
                onClick={onRemove ? () => onRemove(id) : undefined}
                accessibility={{ 'aria-label': title }}
              >
                {truncateTitle ? (
                  <Tooltip target={id} description={title}>
                    <span id={id}>{title}</span>
                  </Tooltip>
                ) : (
                  <span>{title}</span>
                )}
              </Title>
            </li>
          );
        })}
        {toggleButton && <li>{toggleButton}</li>}
      </ul>
    </div>
  );
};

ResourceTitles.propTypes = {
  resources: PropTypes.array.isRequired,
  onRemove: PropTypes.func,
};

ResourceTitles.defaultProps = {
  onRemove: null,
};

export default ResourceTitles;
